// extracted by mini-css-extract-plugin
export default {"shadowed":"BaseLayout_shadowed__sNaX8","dark":"BaseLayout_dark__km+Xv","fade-in":"BaseLayout_fade-in__lpU+2","visible":"BaseLayout_visible__XDfU2","light":"BaseLayout_light__ldtJE"};